import {
  AfterViewInit,
  Component,
  DoCheck,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { EMPTY_GUID } from "apps/resource-portal/src/app/constants/app.constant";
import { AcquisitionService } from "apps/resource-portal/src/app/services/acquisition.service";
import { CutSheetService } from "apps/resource-portal/src/app/services/cut-sheet.service";
import { RoomService } from "apps/resource-portal/src/app/services/room.service";
import {
  catchError,
  concatMap,
  delay,
  EMPTY,
  forkJoin,
  from,
  map,
  mergeMap,
  Observable,
  of,
  reduce,
  retry,
  retryWhen,
  Subject,
  take,
  takeUntil,
  tap,
  toArray,
} from "rxjs";

import { ZipService } from "apps/resource-portal/src/app/services/zip.service";

var json = require("./test.json");
@Component({
  selector: "concourse-print-cutsheet",
  templateUrl: "./print-cutsheet.component.html",
  styleUrls: ["./print-cutsheet.component.scss"],
})
export class PrintCutsheetComponent implements OnInit, OnDestroy {
  processing: number = 0;
  progressbar = { width: "0%" };
  $unsubscribe = new Subject<void>();
  currentProgress = 0;
  acquisitionChange: boolean = false;
  @Input() projectId: any;
  @Input() projectType: any;
  @Input() projectName: any;
  @Input() JSNId: any;
  @Input() selectedRoom: any;
  @Input() selectedDepartment: any;
  @Input() rooms: any;
  @Input() departments: any;
  @Input() JSNs: any;
  @Input() isFromMilStd: boolean = false;
  selectedJSN: any = [];
  selectedAcquisitionCodes: any = [];
  printCutsheetForm!: UntypedFormGroup;
  acquisitionCodes: any;
  fromJsnDone: boolean = false;
  submitted: boolean = false;
  fileName: string = "";
  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private _cutSheetService: CutSheetService,
    private _roomService: RoomService,
    private _acquisitionService: AcquisitionService,
    private zipService: ZipService
  ) { }

  onCheckboxChange(type, item: any, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.addValue(type, item);
    } else {
      this.removeValue(type, item);
    }
  }
  addValue(type, jsn: any) {
    if (type == "JSN") {
      if (!this.selectedJSN.includes(jsn)) {
        this.selectedJSN = [...this.selectedJSN, jsn];
      }
    } else {
      if (!this.selectedAcquisitionCodes.includes(jsn)) {
        this.selectedAcquisitionCodes = [...this.selectedAcquisitionCodes, jsn];
      }
    }
  }

  removeValue(type, jsn: any) {
    if (type == "JSN") {
      this.selectedJSN = this.selectedJSN.filter((item) => item !== jsn);
    } else {
      this.selectedAcquisitionCodes = this.selectedAcquisitionCodes.filter(
        (item) => item !== jsn
      );
    }
  }
  isSelected(type, item: any): boolean {
    if (type == "JSN") {
      return this.selectedJSN.includes(item);
    } else {
      return this.selectedAcquisitionCodes.includes(item);
    }
  }

  isAllSelected(type): boolean {
    if (type == "JSN") {
      return this.JSNs.length === this.selectedJSN.length;
    } else {
      return (
        this.acquisitionCodes.length === this.selectedAcquisitionCodes.length
      );
    }
  }
  toggleSelectAll(type, event: any): void {
    if (event.target.checked) {
      if (type == "JSN") {
        this.selectedJSN = [...this.JSNs];
      } else {
        this.selectedAcquisitionCodes = [...this.acquisitionCodes];
      }
    } else {
      if (type == "JSN") {
        this.selectedJSN = [];
      } else {
        this.selectedAcquisitionCodes = [];
      }
    }
  }
  initForm() {
    this.printCutsheetForm = this.formBuilder.group({
      project: this.projectId ? this.projectId : "",
      department: [this.selectedDepartment],
      groupbydepartment: [0],
      room: this.selectedRoom ? this.selectedRoom : "",
      catcode: [[]],
      mtr: ["1"],
      excludeprice: [true],
      jsn: [, Validators.required],
    });
    this.printCutsheetForm
      .get("department")
      .valueChanges.subscribe((department: any) => {
        if (!department) return;
        this.getJSN();
      });

    this.printCutsheetForm.get("mtr").valueChanges.subscribe((mtr) => {
      this.getJSN();
    });
    // if (this.JSNId)
    //   this.addValue(
    //     "JSN",
    //     this.JSNs.find((jsn) => jsn.id == this.JSNId)
    //   );
    this.printCutsheetForm.get("catcode").valueChanges.subscribe((catcode) => {
      if (this.acquisitionChange) {
        this.getJSN();
      }
      this.acquisitionChange = true;
    });
  }
  ngOnInit(): void {
    console.log(this.projectName);

    if (!this.selectedDepartment) this.getDepartmentByProject(this.projectId);

    this.initForm();

    this.getJSN();

    this._acquisitionService
      .getAllAcquisitionCodes(this.projectType)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result && result.length > 0) {
          this.acquisitionCodes = result;
        }
      });
  }

  chunkArray(array, chunkSize) {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  printDepartmentWise() {
    this.processing = 1;
    if (!this.departments.length) return;

    let totalJSNs = 0;
    let completedFiles = 0;
    let progressP = 0;
    let multipleInterval

    // first collect JSNs per department (same as your code using forkJoin already)
    forkJoin(this.departments.map((department) => {
      let body = {
        project: this.projectId,
        department: department.id,
        mtr: this.printCutsheetForm.get("mtr").value,
        acquisitioncode: this.printCutsheetForm.get("catcode").value.map((item) => item.id),
        ismillstdproject: this.isFromMilStd,
      };
      return this._cutSheetService.getJSN(body).pipe(
        takeUntil(this.$unsubscribe),
        tap((res) => {
          totalJSNs += res.length;
        }),
        map((res) => ({ departmentid: department.id, departmentname: department.departmentname, jsns: res }))
      );
    })).pipe(
      takeUntil(this.$unsubscribe),
      tap(res => {
        multipleInterval = setInterval(() => {
          if (progressP < 20) progressP++;
          if (progressP >= 20 && progressP < 40) progressP += 0.8;
          if (progressP >= 40 && progressP < 60) progressP += 0.6;
          if (progressP >= 40 && progressP < 60) progressP += 0.4;
          if (progressP >= 60 && progressP < 75) progressP += 0.2;
          if (progressP >= 75 && progressP < 99) progressP += 0.8;
          this.progressbar.width = `${Math.floor(progressP)}%`;
        }, ((totalJSNs * 2) / 100) * 1000);
      })).subscribe(async (departmentsWithJsns: any[]) => {

        const concurrency = 4
        const allDepartmentResults = [];
        const printBodies = []

        for (const dept of departmentsWithJsns) {
          const allJSNs = dept.jsns;
          const JSN_CHUNKS = this.chunkArray(allJSNs, 25); // your chunk size

          const bodies = JSN_CHUNKS.map(jsnChunk => ({
            project: this.printCutsheetForm.get("project").value,
            department: dept.departmentid,
            price: this.printCutsheetForm.get("excludeprice").value,
            room: "",
            jsn: jsnChunk.map(jsn => ({ id: jsn.id, jsnother: jsn.jsnother, name: jsn.name, nomenclature: jsn.nomenclature })),
            departmentname: dept.departmentname
          }));

          printBodies.push(...bodies)
        }

        const responses = await from(printBodies).pipe(
          mergeMap(
            body =>
              this._cutSheetService.printCutsheet(body).pipe(
                retry({ count: 10, delay: 3000 }),
                delay(300),
                tap(res => {
                  completedFiles += (res?.files?.length || 0);
                  let currentProgress = (completedFiles / totalJSNs) * 100;

                  if (currentProgress > progressP) {
                    progressP = currentProgress;
                    this.progressbar.width = `${Math.floor(progressP)}%`;
                  }
                }),
                // Map the response to an object that includes the original body/payload
                map(response => ({
                  payload: body,
                  response: response
                }))
              ),
            concurrency
          ),
          toArray() // collect all responses in an array
        ).toPromise();
        // after all departments processed
        this.processing = 2;
        this.progressbar.width = '100%';
        this.zipService.createFolderZip(this.projectName, responses);
      }, err => {
        console.error('Error collecting JSNs by department:', err);
        this.processing = 3;
      });
  }
  print() {
    let departmentwise = this.printCutsheetForm.get("groupbydepartment").value == 1 && this.printCutsheetForm.get("department").value == EMPTY_GUID;
    if (departmentwise) {
      this.printDepartmentWise()
    } else {
      //  filename
      const filename = () => {
        let name;
        if (this.fileName && this.fileName == "ALL") {
          name = this.projectName;
        } else if (
          this.selectedDepartment &&
          this.selectedDepartment != EMPTY_GUID
        ) {
          name = this.departments.find(
            (dept) => dept.id == this.selectedDepartment
          ).departmentname;
        } else if (this.fileName) {
          name = this.fileName;
        } else {
          name = this.projectName;
        }
        console.log(name);

        return name;
      };

      //progressbar
      console.log(this.projectName);

      this.submitted = true;

      let jsns = this.printCutsheetForm.value.jsn.map((jsn: any) => {
        return {
          id: jsn.id,
          name: jsn.name,
          jsnother: jsn?.jsnother || "",
          nomenclature: jsn?.nomenclature,
          manufacturer: jsn?.manufacturer?.id,
          manufacturername: jsn?.manufacturer?.name,
        };
      });

      if (!jsns.length) {
        return;
      }

      this.processing = 1;

      // let filesLength =25;
      let filesLength =
        Math.ceil(jsns.length / 24.84) > 25 ? 25 : Math.ceil(jsns.length / 24.84);
      console.log("Total Jsns==>", jsns.length);
      console.log("Chunk size==>", filesLength);

      let iterations = Math.ceil(jsns.length / filesLength);
      let chunks: any[] = [];

      for (let i = 0; i < iterations; i++) {
        let chunk = jsns.slice(i * filesLength, (i + 1) * filesLength);
        chunks.push(chunk);
      }

      let apiCalls = chunks.map((chunk) => {
        let newBody = {
          project: this.printCutsheetForm.get("project").value,
          department:
            this.printCutsheetForm.get("department").value || EMPTY_GUID,
          price: this.printCutsheetForm.get("excludeprice").value,
          room: "",
          jsn: chunk,
          departmentname:
            this.departments.find(
              (dept) => dept.id == this.printCutsheetForm.get("department").value
            )?.departmentname || "",
        };

        return this._cutSheetService.printCutsheet(newBody);
      });

      let totalRequests = chunks.length,
        completedRequests = 0,
        allJsn = [];

      let progressP = 0;
      const progressInc = () => {
        completedRequests++;

        if ((completedRequests / totalRequests) * 100 < progressP) return;
        progressP = (completedRequests / totalRequests) * 100;
        // console.log("progress==>", progressP);

        this.progressbar.width = `${Math.floor(progressP)}%`;
      };

      if (jsns.length == 1) {
        var singleInterval = setInterval(() => {
          if (progressP >= 99) return;
          console.log(progressP + 1);
          progressP++;
          // console.log("progress==>", progressP);
          this.progressbar.width = `${Math.floor(progressP)}%`;
        }, 60);
      } else {
        var multipleInterval = setInterval(() => {
          if (progressP >= 99) return;
          progressP++;
          // console.log("progress==>", progressP);
          this.progressbar.width = `${Math.floor(progressP)}%`;
        }, ((jsns.length * 6) / 100) * 100);
      }

      from(apiCalls)
        .pipe(
          mergeMap(
            (apiCall) =>
              apiCall.pipe(
                retry({
                  count: 10,
                  delay: 3000,
                }),
                delay(300),
                tap(() => progressInc())
              ),
            4 //concurrencys
          ),
          toArray(),
          takeUntil(this.$unsubscribe)
        )
        .pipe(takeUntil(this.$unsubscribe))
        .subscribe({
          next: (results) => {
            results.forEach((res: any, index) => {
              allJsn = [...allJsn, ...res.files];
            });
          },
          error: (err) => {
            console.error("Error occurred:", err);
          },
          complete: () => {
            this.processing = 2;

            clearInterval(singleInterval);
            clearInterval(multipleInterval);

            if (allJsn.length > 1) {
              this.zipService.createZip(filename(), allJsn);
            } else {
              this.zipService.createPdf(allJsn);
            }
          },
        });
    }
  }

  getDepartmentByProject(projectId: any) {
    this._roomService
      .getDepartmentByProjectId(projectId)
      .pipe(
        catchError((err) => {
          console.error("Error fetching departments", err);
          return EMPTY; // Handle error gracefully
        })
      )
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.departments = result;
          this.initForm();
        }
      });
  }
  deptChange(e) {
    this.fileName = e.target.options[e.target.selectedIndex].innerText;
  }
  getJSN() {
    this.printCutsheetForm.get("jsn").patchValue([]);
    let body = {
      project: this.projectId,
      department: this.printCutsheetForm.get("department").value,
      mtr: this.printCutsheetForm.get("mtr").value,
      acquisitioncode: this.printCutsheetForm
        .get("catcode")
        .value.map((item) => item.id),
      ismillstdproject: this.isFromMilStd,
    };
    this._cutSheetService
      .getJSN(body)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res: any) => {
        this.JSNs = res.map((jsn) => {
          return {
            ...jsn,
            jsnlabel: jsn.name + (jsn.jsnother ? " " + jsn.jsnother : ""),
            jsnlabelNomenclature:
              jsn.name +
              (jsn.jsnother ? " " + jsn.jsnother : "") +
              (jsn.nomenclature ? " - " + jsn.nomenclature : ""),
          };
        });

        this.printCutsheetForm.get("jsn").patchValue([]);

        if (this.JSNId && !this.fromJsnDone) {
          this.printCutsheetForm
            .get("jsn")
            .patchValue([this.JSNs.find((jsn) => jsn.id == this.JSNId)]);
          this.fromJsnDone = true;
        }
      });
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
  onItemRemoved(e) {
    console.log(e);
  }
}
